import Image from 'next/legacy/image';
import type { ImageProps } from 'next/legacy/image';

const ResponsiveImage = (props: ImageProps) => (
  <Image layout="fill" objectFit="cover" {...props} />
);

export { ResponsiveImage };
